<template>
  <div id="app">
    <div class="app-container">
      <div class="app-header">
        <div class="app-logo">
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/logo.png"
            alt
          />
          {{
            isChinese
              ? "宁波渔遥科技有限公司"
              : "Ningbo Globfishing Technologies Inc"
          }}
        </div>
        <div
          :style="{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }"
        >
          <el-menu
            v-if="isMenuShow"
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
            text-color="rgb(10, 113, 210)"
            active-text-color="rgb(10, 113, 210)"
          >
            <el-menu-item index="/">{{
              isChinese ? "关于渔遥" : "About"
            }}</el-menu-item>
            <el-menu-item index="/product">{{
              isChinese ? "渔遥渔鹰" : "FishAwk"
            }}</el-menu-item>
            <el-menu-item index="/product1">{{
              isChinese ? "渔精灵" : "FishFairy"
            }}</el-menu-item>
            <el-menu-item index="/case">{{
              isChinese ? "加入我们" : "Join"
            }}</el-menu-item>
            <el-menu-item index="/contact">{{
              isChinese ? "联系我们" : "Contact"
            }}</el-menu-item>
          </el-menu>
          <el-dropdown @command="handleCommand" v-else>
            <span class="el-dropdown-link">
              {{ module }}
              <span class="arrow-down"></span>
              <!-- <i class="el-icon-arrow-down"></i> -->
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="关于渔遥">{{
                isChinese ? "关于渔遥" : "About"
              }}</el-dropdown-item>
              <el-dropdown-item command="渔遥渔鹰">{{
                isChinese ? "渔遥渔鹰" : "FishAwk"
              }}</el-dropdown-item>
              <el-dropdown-item command="渔精灵">{{
                isChinese ? "渔精灵" : "FishFairy"
              }}</el-dropdown-item>
              <el-dropdown-item command="加入我们">{{
                isChinese ? "加入我们" : "Join"
              }}</el-dropdown-item>
              <el-dropdown-item command="联系我们">{{
                isChinese ? "联系我们" : "Contact"
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <div class="language">
            <span :style="chineseStyle" @click="onChineseClick">中</span>
            <span :style="englishStyle" @click="onEnglishClick">EN</span>
          </div> -->
        </div>
      </div>
      <router-view />
      <div class="app-footer">
        <div class="footer-top">
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: column;
              min-width: 380px;
            "
          >
            <!-- <i class="iconfont icon-dianhua phone-icon"></i> -->
            <svg class="iconfont phone-icon" aria-hidden="true">
              <use xlink:href="#icon-dianhua"></use>
              <!-- 对应你的图标名 -->
            </svg>
            <span class="tip">0574-87184121</span>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: column;
              min-width: 380px;
            "
          >
            <!-- <i class="iconfont icon-youjian email-icon"></i> -->
            <svg class="iconfont email-icon" aria-hidden="true">
              <use xlink:href="#icon-youjian"></use>
              <!-- 对应你的图标名 -->
            </svg>
            <span class="tip">service@aispatial.com</span>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: column;
              min-width: 380px;
            "
          >
            <!-- <i class="iconfont icon-zuobiao location-icon"></i> -->
            <svg class="iconfont location-icon" aria-hidden="true">
              <use xlink:href="#icon-zuobiao"></use>
              <!-- 对应你的图标名 -->
            </svg>
            <span class="tip">宁波市鄞州区国际金融中心E座23楼</span>
          </div>

          <!-- <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/footer-phone.png"
            alt=""
          />
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/new-footer-mail3.png"
            alt=""
          />
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/footer-location.png"
            alt=""
          /> -->
        </div>
        <div class="footer-bottom">
          <a
            href="https://beian.mps.gov.cn/#/query/websearch?code=33021202002935"
            rel="noreferrer"
            target="blank"
            >浙公网安备33021202002935号</a
          >
          <div class="copyright">
            <span>Copyright © 2022 宁波渔遥科技有限公司 </span>
            <a href="https://beian.miit.gov.cn" target="_blank">
              <span> 浙ICP备2022036249</span>
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="app-footer" v-show="true">
        <div class="footer-content">
          <div class="footer-img-container">
            <img src="./assets/img/footer-phone.png" alt="" />
            <img src="./assets/img/footer-mail.png" alt="" />
            <img src="./assets/img/footer-location.png" alt="" />
          </div>
        </div>
        <div class="network-security">
          <a
            href="https://beian.mps.gov.cn/#/query/websearch?code=33021202002935"
            rel="noreferrer"
            target="blank"
            >浙公网安备33021202002935号</a
          >
        </div>
        <div class="copyright">
          <span>Copyright © 2022 宁波渔遥科技有限公司 </span>
          <a href="https://beian.miit.gov.cn" target="_blank">
            <span> 浙ICP备2022036249</span>
          </a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      module: "关于渔遥",
    };
  },
  computed: {
    ...mapState(["isChinese"]),
    isMenuShow() {
      return document.documentElement.clientWidth > 768;
    },
    chineseStyle() {
      return this.isChinese ? {} : { color: "rgb(186,194,201)" };
    },
    englishStyle() {
      return this.isChinese ? { color: "rgb(186,194,201)" } : {};
    },
  },
  methods: {
    onChineseClick() {
      this.$store.commit("updateLanguage", true);
    },
    onEnglishClick() {
      this.$store.commit("updateLanguage", false);
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
    handleCommand(command) {
      if (this.module == command) {
        return;
      }
      this.module = command;
      switch (command) {
        case "关于渔遥":
          this.$router.replace("./");
          break;
        case "渔遥渔鹰":
          this.$router.replace("./product");
          break;
        case "渔精灵":
          this.$router.replace("./product1");
          break;
        case "加入我们":
          this.$router.replace("./case");
          break;
        case "联系我们":
          this.$router.replace("./contact");
          break;
      }
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  // height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.arrow-down {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-left: 2px solid rgb(10, 113, 210); /* 左侧边框为实线 */
  border-bottom: 2px solid rgb(10, 113, 210); /* 底部边框为实线 */
  transform: rotate(-45deg); /* 旋转-45度（尖端向下） */
}
.app-container {
  display: flex;
  flex-direction: column;
  .app-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    // position: absolute;
    // z-index: 100;
    width: 100%;
    // padding: 15px 10px 5px 10px;
    box-sizing: border-box;
    color: rgb(10, 113, 210);
    //background-color: #fff;

    .app-logo {
      // width: 280px;
      text-align: center;
      line-height: 60px;
      font-size: 24px;
      display: flex;

      img {
        width: 60px;
        height: 60px;
        margin-right: 20px;
      }
    }
  }
}

.app-footer {
  background-color: #4774b6;
  display: flex;
  flex-direction: column;
  .footer-top {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 30px 0 20px 0;
    img {
      height: 120px;
    }
    .iconfont {
      width: 44px;
      height: 44px;
      fill: white;
    }
    .email-icon {
      font-size: 46px;
    }
    .location-icon {
      font-size: 46px;
    }
    .tip {
      color: white;
      font-weight: bold;
      font-size: 24px;
    }
  }
  .footer-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding-bottom: 20px;
    color: white;
  }
}

.language {
  display: flex;
  gap: 20px;
  font-size: 25px;
  margin-left: 20px;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "PingFangSC-Regular";
    cursor: pointer;
  }
}
.el-menu {
  border-bottom: none !important;
}
.el-menu-item {
  font-size: 20px !important;
  height: auto !important;

  background-color: white !important;
  color: rgb(10, 113, 210) !important;
}
.is-active {
  background-color: rgb(10, 113, 210) !important;
  color: white !important;
}
.el-dropdown-link {
  font-size: 18px;
  cursor: pointer;
  color: rgb(10, 113, 210);
  display: flex;
  align-items: center;
  gap: 5px;
}
@media (max-width: 1300px) {
  .app-footer {
    .footer-top {
      padding: 20px 0 10px 0;
      img {
        height: 80px;
      }
    }
  }
}
@media (max-width: 768px) {
  .app-footer {
    .footer-top {
      padding: 10px 0 5px 0;
      img {
        height: 50px;
      }
    }
  }
}
</style>
